import { useEffect, useRef } from "react";
import ViewPromotionManualDTO from "../dto/ViewOfferPromotionDTO";
import * as journifyTrackingCarEvents from "../services/trackingCarEvents";

const pick = (obj, keys, fallback = undefined) => {
  for (const k of keys) {
    if (obj && obj[k] !== undefined && obj[k] !== null) return obj[k];
  }
  return fallback;
};

const toNumber = (v, def = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : def;
};

const toString = (v, def = "") => (v === undefined || v === null ? def : String(v));


export default function useTrackSelectVehicleOfferPromotion({ banner, SupportedVehicles, lang }) {
  const firedRef = useRef("");

  useEffect(() => {
    if (!banner || !Array.isArray(SupportedVehicles) || SupportedVehicles.length === 0) return;

    const key = `${lang}-${banner?.slug || ""}-${SupportedVehicles.length}`;
    if (firedRef.current === key) return;
    firedRef.current = key;

    const dto = new ViewPromotionManualDTO({
      promotion_id: lang === "ar" ? banner?.otherLink : banner?.slug,
      promotion_name: banner?.title,
      creative_name: banner?.title,
      creative_slot: "vehicle-offers",
      items: [],
    });

    SupportedVehicles.forEach((car, idx) => {
      dto.addItem({
        item_id: toString(pick(car, ["ProductNo", "productNo", "product_no", "ProductID", "ProductId"]), ""),
        item_name: toString(pick(car, ["DescriptionAr", "DescriptionEn", "ModelTypes", "Type English", "nameAr", "nameEn"]), ""),
        item_brand: toString(pick(car, ["brand", "brandEn"]), "value"),
        item_category: toString(pick(car, ["group", "groupEn"]), "value"),
        item_category2: toString(pick(car, ["Year", "year"]), "value"),
        item_category3: toString(pick(car, ["vehicleType"]), "value"),
        item_category4: toString(pick(car, ["carGroupID", "carGroupId"]), "value"),
        item_category5: toString(pick(car, ["type"]), "value"),
        item_list_id: toString(pick(car, ["item_list_id"]), "value"),
        item_list_name: toString(pick(car, ["item_list_name"]), "value"),
        location_id: toString(pick(car, ["location_id"]), "value"),
        index: idx,
        price: toNumber(pick(car, ["MinPrice", "minPrice", "RetailPrice", "DealerPrice"]), 0),
        quantity: toNumber(pick(car, ["Qty", "quantity"]), 1),
      });
    });

    if (dto.isValid()) {
      journifyTrackingCarEvents.trackSelectOfferCar(dto.toJSON());
    }
  }, [banner, SupportedVehicles, lang]);
}


